import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import globalMU from "globalMU";
import React, { memo, useMemo } from "react"

const estiloPedidosCliente = require("./pedidosCliente.module.scss").default;
const estiloTabela = require('../../../../estilos/tabelas.module.scss').default

const tableHead = (
    <div className="_table-row">
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Cliente
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Pedidos
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Filial Pedido
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Filial Retirada
        </div>
        <div className={`_table-cell _font-bold _text-right ${estiloPedidosCliente.tableCellHeader}`}>
            Quantidade não Entregue
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Previsão Entrega
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosCliente.tableCellHeader}`}>
            Vendedor
        </div>
    </div>
)

export type PedidosClienteProps = {
    dadosPesquisaPedidosCliente: PagedMessageResponse<DadosPedidoCliente>
    onPesquisarPaginado: (numeroPagina?: number) => void
}

export type DadosPedidoCliente = {
    CodigoCliente: number
    DataPedido: string
    DataPrevisaoEntrega: string
    Filial: string
    FilialRetirada: string
    Nome: string
    NumeroPedido: number
    QuantidadeNaoEntregue: number
    RazaoSocialCliente: string
    Situacao: string
    Vendedor: string
    UserMessage?: string,
    Transforming: boolean
}

export const PedidosCliente = memo((props: PedidosClienteProps) => {

    const tableBody = props.dadosPesquisaPedidosCliente?.Entities?.map((value) => (
        <div key={value.NumeroPedido} className="_table-row ">
            <div style={
                value.Situacao == "2" ?
                    { boxShadow: "4px 0 #fc0 inset" }
                    : { boxShadow: "4px 0 #f00 inset" }
            }
                className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {value.Nome}
            </div>
            <div className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {value.NumeroPedido}
            </div>
            <div className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {value.Filial}
            </div>
            <div className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {value.FilialRetirada}
            </div>
            <div className={`_table-cell _text-right ${estiloPedidosCliente.tableCellBody}`}>
                {globalMU.formatarValorNumerico(value.QuantidadeNaoEntregue, 3, false)}
            </div>
            <div className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {globalMU.formatDate(value.DataPrevisaoEntrega)}
            </div>
            <div className={`_table-cell ${estiloPedidosCliente.tableCellBody}`}>
                {value.Vendedor}
            </div>
        </div>
    ))

    const paginacao = props.dadosPesquisaPedidosCliente?.PageCount > 1 && (
        <Paginacao
            id="PedidosCliente_Paginacao"
            paginaAtual={props.dadosPesquisaPedidosCliente.ActualPage}
            totalPaginas={props.dadosPesquisaPedidosCliente.PageCount}
            onAlterarListaSelecionada={
                props.onPesquisarPaginado
            }
        />
    )

    const quantidadeNaoEntregue = useMemo(() => {
        let total = 0
        props.dadosPesquisaPedidosCliente?.Entities?.forEach((x) => total += x.QuantidadeNaoEntregue)
        return (
            <div>
                <div className="_text-lg _font-bold _text-blue-500 _mb-4">Totais</div>
                <div className={estiloPedidosCliente.dadosQuantidadePerdida}>
                    <label>Quantidade não Entregue</label>
                    <div>{globalMU.formatarValorNumerico(total, 3, false)}</div>
                </div>
            </div>
        )
    }, [props.dadosPesquisaPedidosCliente?.Entities])    

    return (
        <>
            <div className={estiloTabela.containerRolavel}>
            <div className={`_table _w-full _border-collapse ${estiloPedidosCliente.tabelaPedidosCliente}`}>
                <div className="_table-header-group ">
                    {tableHead}
                </div>
                <div className="_table-row-group">
                    {tableBody}
                </div>
            </div>
            </div>

            {paginacao}

            <br />

            {quantidadeNaoEntregue}

            <div>
                <Legenda itens={[
                    {
                        nome: "Faturado/Aguardando Entrega",
                        cor: "#fc0"
                    },
                    {
                        nome: "Aguardando Faturamento",
                        cor: "#f00"
                    },
                ]} />
            </div>
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
})